import React from 'react';
import { Text, Box } from '@rsos/components/capstone/base';

const InboundAlertsEmptyState = () => {
  return (
    <Box justify="center" align="center" height="100%" flow={4}>
      <Text size="large" color="secondaryText" fontWeight="semibold">
        No inbound pairs
      </Text>
      <Text size="normal" color="secondaryText">
        You are not currently receiving alerts from any agencies.
      </Text>
    </Box>
  );
};

export default InboundAlertsEmptyState;
